<template>
  <div class="organization">
    <Title :title="title" />
    <div class="container wow bounceIn" data-wow-offset="400">
      <img :src="column[9]['picurl']" alt="">
    </div>
  </div>
</template>

<script>
import {get_column} from "../../../util/lang";
import Title from '../Title/Title.vue'
export default {
  data() {
    return {
      column:{} ,
      title: {
        en:  '',
      }
    }
  },
  methods: {
    get_content() {
      const url = get_column();
      this.$$axios.get(url).then(res => {
        this.column = res.data
        this.title.en = this.column[9]['title']


        // console.log(this.banner)
        // this.banner.map((item)=>{
        //   item.EN=item.EN.replace(/\n/g, "<br>")
        // })
      })
    },

  },
  created() {
    this.get_content()
  },
  components: {
    Title
  },

}
</script>

<style scoped>
.organization{
  padding: 50px 0;
}
.organization .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
  text-align: center;
}
.organization .container img{
  max-width: 100%;
}

</style>


